import { h, Fragment} from 'preact';
const actions = require('../../actions')
import {Form} from '../elements'

export default (props)=>{
    const {SelectDark} = props
    const setAdministrator = (administrator)=>{
        actions.FilterActions.merge({
            selectedAdministratorID:  administrator.id
        })
    }
    return (
        <div>
            <SelectDark onSelect={setAdministrator} data={props.administrators} />
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/groups/AdministratorSelect.js